document.addEventListener('DOMContentLoaded', () => {
  const partnerBrandsSlider = document.querySelector(".iwt-slider.partner-brands");
  Object.assign(partnerBrandsSlider, {
    slidesPerView: 5,
    spaceBetween: 10,
    loop: true,
    pagination: {
      el: '.slider__pagination.brands',
      clickable: true,
    },
    navigation: {
      nextEl: '.right-arrow',
      prevEl: '.left-arrow',
    },
    breakpoints: {
      1024: {
        slidesPerView: 5,
      },
      768: {
        slidesPerView: 3,
        navigation: false
      },
      480: {
        slidesPerView: 1,
      },
      280: {
        slidesPerView: 1,
      },
    },
  });
  partnerBrandsSlider.initialize();
});